exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".checkout[data-v-06504506] {\n  max-width: 1840px;\n}\n.checkout .tooltip[data-v-06504506] {\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  font-size: 8px;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  color: #fff;\n  margin-left: 4px;\n  cursor: default;\n  background-color: #23B32F;\n}", ""]);

// exports
